import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../../../services/AxiosInstance";
import Api from "../../../../../constants/Api";
import MenuConfig from "../../../../../constants/MenuConfig";
import HintCallout from "../../../../components/Common/HintCallout";

/**
 * Aviso do destaque do mês quando há assinaturas do período sem vendedor.
 *
 * Contrato trazido pela sincronização do provedor chega sem vendedor e não pontua para
 * ninguém; sem o aviso, a empresa via o critério de assinaturas zerado e achava que o
 * cálculo estava errado. O número vem do backend com o mesmo recorte do ranking, e o botão
 * abre a lista de assinantes já filtrada para informar quem vendeu.
 *
 * Fica em um componente só porque o painel e o relatório do destaque mostram o mesmo aviso.
 *
 * @param {{startDate: string, endDate: string, branchId?: number}} props datas em yyyy-MM-dd
 */
const SubscriptionsWithoutSellerNotice = ({ startDate, endDate, branchId }) => {
    const navigate = useNavigate();
    const [count, setCount] = useState(0);

    useEffect(() => {
        if (!startDate || !endDate) {
            setCount(0);
            return undefined;
        }

        // Troca rápida de mês não pode deixar a resposta antiga sobrescrever a nova.
        let active = true;
        axiosInstance.get(Api.performance.highlightSubscriptionsWithoutSeller, {
            params: { startDate, endDate, branchId: branchId || undefined }
        })
            .then(({ data }) => {
                if (active) setCount(Number(data) || 0);
            })
            // Aviso complementar: se a contagem falhar, o ranking continua valendo sem ele.
            .catch(() => {
                if (active) setCount(0);
            });

        return () => {
            active = false;
        };
    }, [startDate, endDate, branchId]);

    if (count <= 0) {
        return null;
    }

    // A lista de assinantes lê estes parâmetros e abre só os contratos sem vendedor do período.
    const openSubscribersWithoutSeller = () => {
        const params = new URLSearchParams({ withoutSeller: "1", startDate, endDate });
        navigate(`${MenuConfig.subscription.subscription.route}?${params.toString()}`);
    };

    const single = count === 1;

    // Título curto com o número, para ser lido de relance; a explicação fica na linha de baixo.
    return (
        <HintCallout
            icon="fa-user-tag"
            tone="warning"
            title={`${count} ${single ? "assinatura" : "assinaturas"} sem vendedor`}
            action={(
                <Button variant="outline-primary" size="sm" onClick={openSubscribersWithoutSeller}>
                    Definir vendedor
                </Button>
            )}
        >
            {single ? "Ela não entrou" : "Elas não entraram"} no ranking deste período. Informe quem vendeu para os pontos contarem.
        </HintCallout>
    );
};

export default SubscriptionsWithoutSellerNotice;
